import ContactTemplateModel from '../models/ContactTemplateModel'

import { useAccountStore } from './stores/useAccountStore'
import { useContactTemplatesStore } from './stores/useContactTemplatesStore'

interface UseContactTemplateReturnType {
   getContactTemplateId: () => string
   getContactTemplate: () => ContactTemplateModel
}

const useContactTemplate = (): UseContactTemplateReturnType => {
   const contactTemplatesStore = useContactTemplatesStore()
   const accountStore = useAccountStore()

   const getContactTemplate = (): ContactTemplateModel => {
      const contactTemplateId = accountStore.contactTemplateId
      if (!contactTemplateId) throw new Error('ContactTemplateId not found')

      const contactTemplate = contactTemplatesStore.getTemplate(
         contactTemplateId
      )
      return contactTemplate
   }

   const getContactTemplateId = (): string => {
      const contactTemplate = getContactTemplate()
      return contactTemplate.templateId
   }

   return {
      getContactTemplateId,
      getContactTemplate
   }
}

export { useContactTemplate }
